import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbActionsModule, NbAutocompleteModule, NbButtonModule, NbCardModule, NbFormFieldModule, NbIconModule, NbInputModule, NbLayoutModule, NbListModule, NbMenuItem, NbMenuModule,NbOptionModule,NbPopoverModule,NbSearchModule,NbSidebarModule, NbTabsetModule } from '@nebular/theme';
import { CmsComponent } from './cms.component';
import { WebSiteComponent } from './website/web-site.component';
import { SurveyComponent } from './survey/survey.component';
import { DataResourceComponent } from './data-resource/data-resource.component';
import { CmsRoutingModule } from './cms-routing.module';
import { WebSiteSettingsComponent } from './website/web-site-settings.component';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { DynamicCmsDirective } from './dynamic-cms.directive';
import { ContentComponent } from './content/content.component';
import { OfbizFormsModule } from '@urbannex/ofbiz-forms';
import { LayoutService } from './layout.service';
import { ToggleSearchDirective } from './dynamic-component-container/toggle-search.directive';
import { ViewContainersService } from '@urbannex/view-containers';
import { BlogComponent } from './blog/blog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ForumsComponent } from './forums/forums.component';


/* const MENU_ITEMS:NbMenuItem[] = [
  {
    title: 'Websites',
    icon: 'globe-outline',
    link: '/admin/cms/websites',
    home: true,
  },
  {
    title: 'Content',
    icon: 'file-text-outline',
    link: '/admin/cms/content',
    home: true,
  },
  {
    title: 'Survey',
    icon: 'clipboard-outline',
    link: '/admin/cms/survey',
  },
  {
    title: 'Blogs',
    icon: 'book-outline',
    link: '/admin/cms/blog',
  },
  {
    title: 'Forum',
    icon: 'people-outline',
    link: '/admin/cms/forums',
  },
  {
    title: 'Data Resource',
    icon: 'cube-outline',
    link: '/admin/cms/data-resource',
  },
  {
    title: 'Gallery',
    icon: 'color-palette-outline',
    link: '/pages/iot-dashboard',
  },
  {
    title: 'Editors',
    icon: 'text-outline',
    children: [
      {
        title: 'TinyMCE',
        link: '/pages/editors/tinymce',
      },
      {
        title: 'CKEditor',
        link: '/pages/editors/ckeditor',
      },
    ],
  },
  {
    title: 'Tables & Data',
    icon: 'grid-outline',
    children: [
      {
        title: 'Smart Table',
        link: '/pages/tables/smart-table',
      },
      {
        title: 'Tree Grid',
        link: '/pages/tables/tree-grid',
      },
    ],
  },

];

const headerTitle:string = "CMS";

const menuAndTitleOptions = {menuItems:MENU_ITEMS,headerTitle:headerTitle}; */

@NgModule({
  declarations: [CmsComponent, WebSiteComponent, SurveyComponent, DataResourceComponent, WebSiteSettingsComponent, DynamicCmsDirective, ContentComponent, BlogComponent, ForumsComponent],
  imports: [
    CommonModule,
    NbLayoutModule,
    CmsRoutingModule,
    NbCardModule,
    NbActionsModule,
    NbEvaIconsModule,
    NbSidebarModule,
    NbListModule,
    NbIconModule,
    NbTabsetModule,
    NbSearchModule,
    NbInputModule,
    NbFormFieldModule,
    NbButtonModule,
    NbPopoverModule,
    NbOptionModule,
    NbAutocompleteModule,
    ReactiveFormsModule,
    OfbizFormsModule.forRoot("https://kwikstore-dev:8443/rest/")
  ],
  exports: [CmsComponent,WebSiteComponent,SurveyComponent,DataResourceComponent,ForumsComponent,WebSiteSettingsComponent,DynamicCmsDirective],
  providers:[LayoutService,ViewContainersService]
})
export class CmsModule { }
